import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BarGraph from "../../components/graphs/BarGraph";
import dataService from "../../networks/api/service/dataService";

function PanchayatGraphDetails() {
  const [panchayat, setpanchayat] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { assemblyName } = location.state || {};

  const getPanFromAssembly = async () => {
    const data = { assembly: id };
    try {
      const res = await dataService.getPanchayatFromAssembly(data);
      if (res.code === 200) {
        setpanchayat(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleBarClick = (data) => {
    if (data._id) {
      navigate(`/login/bhooth-graph-details/${data._id}`, {
        state: { panchayatName: data.panchayatName },
      });
    }
  };

  useEffect(() => {
    getPanFromAssembly();
  }, [id]);
  return (
    <div>
      <div>
        <BarGraph
          data={panchayat}
          xKey="panchayatName"
          title={`Details for Assembly : ${assemblyName}`}
          bars={[
            {
              key: "totalPopulation",
              color: "#8884d8",
              name: "Total Population",
            },
            { key: "totalMaleVoter", color: "#82ca9d", name: "Male Voters" },
            {
              key: "totalFemaleVoter",
              color: "#ffc658",
              name: "Female Voters",
            },
          ]}
          onBarClick={handleBarClick}
        />
      </div>
    </div>
  );
}

export default PanchayatGraphDetails;
